import React from "react"

export const Bills = () => {
    return (
        <div className="container">
            <h1>Мои счета (в процессе разработки)</h1>
        </div>
    )
}
